/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MandatsdatumInputs */

const de__field_mandatsdatum = /** @type {(inputs: _Field_MandatsdatumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandatsdatum`)
};

/**

* @param {_Field_MandatsdatumInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_mandatsdatum = /** @type {((inputs?: _Field_MandatsdatumInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MandatsdatumInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_mandatsdatum(inputs)
});